 
import t from "prop-types";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@material-ui/icons/Close";
import { toastifyStyles } from "@app/common/toastifyStyles";

const CloseBtn = ({ closeToast }) => (<CloseIcon onClick={closeToast} />);
CloseBtn.propTypes = { closeToast: t.func.isRequired };

const NotificationCenterComponent = () => <ToastContainer rtl css={toastifyStyles} autoClose={8000} closeButton={CloseBtn} />;

export default NotificationCenterComponent;

